import { Utils } from "@/utilities/Utils";

export class EmployeeScanHistoryRequest {
    id: number = 0;
    redFlagOnly: boolean = false;
    startDate: Date | null = null;
    endDate: Date | null = null;
    resultType: number = 0;
}